import { FilterItem, FilterItemArray } from '@ocean/types/dist/filter'
import { Breadcrumb } from 'types'
import { Card } from 'types/card'

export enum AdaptiveLearningEvents {
  AssessmentPlayer = 'OLP_ADAPTIVE_LEARNING_ASSESSMENT',
  ContentPlayer = 'VIEW_ADAPTIVE_LEARNING_LEARNING_CONTENT',
  Disable = 'DISABLE_ADAPTIVE_LEARNING',
  ExitAssessmentPlayer = 'EXIT_ASSESSMENT_PLAYER',
  ExitContentPlayer = 'EXIT_ADAPTIVE_LEARNING_CONTENT_PLAYER',
  ExitHome = 'EXIT_HOME',
  ExitLibrary = 'EXIT_LIBRARY',
  ExitAssessmentLauncher = 'EXIT_ASSESSMENT_LAUNCHER',
}

export type AdaptiveLearningContext = {
  moduleId?: string
  sessionId?: string
  assessmentId?: string
}

export type AdaptiveLearningEvent = AdaptiveLearningContext & {
  type: AdaptiveLearningEvents
}

export type RequirementsGroupResponse = {
  name: string
  description?: string
  content: Card[]
  breadcrumbs: Breadcrumb[]
  total: number
  approved: number
  requirementInstruction?: string
}

export type RequirementsFilterItems = {
  requirementStatus: FilterItemArray
  criticalForRank: FilterItem
  readyToBeAssessed: FilterItem
  activityType: FilterItemArray
  availability: FilterItem
}

export type RequirementsFilterItemNames = keyof RequirementsFilterItems

export type RequirementsFilterItem = RequirementFilterItemSingle | RequirementFilterItemArray

export type RequirementFilterItemSingle = {
  name: RequirementsFilterItemNames
  value: FilterItem['value']
}

export type RequirementFilterItemArray = {
  name: RequirementsFilterItemNames
  value: FilterItemArray['value']
}
